import { gql } from 'graphql-request';

export const SEND_TO_CORRECT_SHIPMENT_TASK = gql`
  mutation App5182dd71_Document($documentId: String!) {
    app5182dd71_ShipmentTask {
      sendToCorrect(documentId: $documentId) {
        status
        message {
          ru
          en
        }
      }
    }
  }
`;
